const ALL = "all"

const mapBenchmarkSettings = benchmarkSettings => {
  if (!benchmarkSettings) return null

  const { recruiterType, industry, companySize } = benchmarkSettings
  const industryId = industry.id !== ALL ? industry.id : null
  const companySizeId = companySize.id !== ALL ? companySize.id : null

  return { recruiterType, industryId, companySize: companySizeId }
}

export default mapBenchmarkSettings
